import React from 'react';
import ReactDOM from 'react-dom/client';
import LogRocket from 'logrocket';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@emotion/react';
import PortfolioTheme from './layout/Theme/PortfolioTheme';
import "@fontsource/poppins";
import '@fontsource/oooh-baby';

const {
  REACT_APP_ENV,
  REACT_APP_LOG_ROCKET_APP_ID
} = process.env;

LogRocket.init(
  REACT_APP_LOG_ROCKET_APP_ID,
  {
    shouldCaptureIP: true,
    shouldDebugLog: REACT_APP_ENV === "local"
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={PortfolioTheme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
